import React, { useEffect, useState } from "react";
import BannerCard from "./BannerCard";
import "./BannerCarousel.css";

export default function BannerCarousel({
    context,
    banners = [],
    visibleItems = 1,
    onBannerClick
}) {

    const [currentPage, setCurrentPage] = useState(0);

    const totalPages = Math.ceil(banners.length / visibleItems);

    const startIndex = currentPage * visibleItems;

    const visibleBanners = banners.slice(
        startIndex,
        startIndex + visibleItems
    );


    useEffect(() => {
        getBannerData();
    }, []);

    function next() {

        if (currentPage < totalPages - 1) {

            setCurrentPage(currentPage + 1);

        }

    }

    const getBannerData = async () => {
        try {
            const { idToken } = context;

            const headers = {
                Authorization: `Bearer ${idToken}`
            };

            const response = await fetch("/Banners/GetBanners", { headers });

            if (!response.ok) {
                //Erro
                return;
            }

            const data = await response.json();

            console.log(JSON.stringify(data));

        } catch (error) {
            console.error("Error fetching protection data:", error);
        }
    }

    function previous() {

        if (currentPage > 0) {

            setCurrentPage(currentPage - 1);

        }

    }

    return (
        <div className="banner-carousel-container">
            <span className="banner-carousel-title">Mais para si</span>
            <div className="banner-carousel">
                <div className="banner-carousel__content">
                    {visibleBanners.map((banner) => (
                        <BannerCard
                            key={banner.id}
                            banner={banner}
                            onClick={() => onBannerClick?.(banner)}
                        />
                    ))}
                </div>
                <div className="banner-carousel__navigation">
                    <button
                        disabled={currentPage === 0}
                        onClick={previous}
                    >
                        ←
                    </button>
                    <button
                        disabled={currentPage === totalPages - 1}
                        onClick={next}
                    >
                        →
                    </button>
                </div>
            </div>
        </div>
    );

}